import { TableCell, TableRow } from "@/components/ui/table";
import { flexRender, Table } from "@tanstack/react-table";
import { standingOfferColumns } from "../../assets/StandingOfferColumns";
import { StandingOfferTable } from "../../types/subscriptions.type";

interface Props<TData> {
  table: Table<TData>;
}

export function StandingOffersTableContent<TData extends StandingOfferTable>({
  table
}: Props<TData>) {
  return table.getRowModel().rows.length ? (
    table.getRowModel().rows.map((row) => (
      <TableRow
        className="h-16 group"
        key={row.id}
        data-testid="standingOfferRow"
      >
        {row.getVisibleCells().map((cell) => (
          <TableCell className="first:w-16 last:w-10" key={cell.id}>
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </TableCell>
        ))}
      </TableRow>
    ))
  ) : (
    <TableRow data-testid="standingOffersEmpty">
      <TableCell
        colSpan={standingOfferColumns.length}
        className="h-16 text-center"
      >
        No standing offers found
      </TableCell>
    </TableRow>
  );
}
